import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrackingService } from 'app/services/tracking.service';
import { RankingsAnonFormService } from '../../../services/rankings-anon-form.service';

declare var hbspt;

@Component({
  selector: 'app-rankings-anon-form',
  template: '<div class="download-form {{classRef}}"></div>',
  styleUrls: ['./rankings-anon-form.component.scss']
})
export class RankingsAnonFormComponent implements OnInit {
  @Input()
  classRef: string;

  @Output()
  formSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  formReady: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private _tracking: TrackingService,
    private _service: RankingsAnonFormService
  ) {}

  ngOnInit(): void {
    if (this.classRef) {
      hbspt.forms.create({
        region: 'na1',
        portalId: '2364596',
        formId: 'd4397ea7-7a3f-4f5d-a27b-2416d7370d3b',
        target: `.${this.classRef}`,
        onFormSubmit: $form => {
          const email = $form[0][0].value;
          this._tracking.eventTrack('ratings_form_email', {
            email: email
          });
          this._service.submitForm();
        },
        onFormSubmitted: callback => {
          this.formSubmit.emit(true);
        },
        onFormReady: $form => {
          this.formReady.emit(true);
          return true;
        }
      });
    }
  }
}
